export default "__VITE_ASSET__068e401c__"